import { render, staticRenderFns } from "./ListSuppliers.vue?vue&type=template&id=409d34ee&"
import script from "./ListSuppliers.vue?vue&type=script&lang=js&"
export * from "./ListSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports